module.exports = __webpack_public_path__ + "static/media/additionButtonDisabled.406c8cca.svg";